export function isInElectron(serverUserAgent?: string) {
  let isElectron = false;
  if (typeof window !== 'undefined' || serverUserAgent) {
    const userAgent = (serverUserAgent || navigator.userAgent).toLowerCase();
    if (userAgent.indexOf(' electron/') > -1) {
      isElectron = true;
    }
  }
  return isElectron;
}

export function isMacintosh(serverUserAgent?: string) {
  if (typeof window !== 'undefined' || serverUserAgent) {
    const userAgent = (serverUserAgent || navigator.userAgent).toLowerCase();
    if (userAgent.indexOf('macintosh;') > -1) {
      return true;
    }
  }
  return false;
}

export function isiOSApp(serverUserAgent?: string) {
  if (typeof window !== 'undefined' || serverUserAgent) {
    const userAgent = serverUserAgent || navigator.userAgent;
    if (userAgent.indexOf('JicooiOSApp') > -1) {
      return true;
    }
  }
  return false;
}

export function isSmartPhoneApp(serverUserAgent?: string) {
  return isIPhone(serverUserAgent) || isAndroid(serverUserAgent);
}

export function isMobileApp(serverUserAgent?: string) {
  return isIPad(serverUserAgent) || isSmartPhoneApp(serverUserAgent);
}

export function isIPhone(serverUserAgent?: string) {
  let userAgent;
  if (serverUserAgent) {
    userAgent = serverUserAgent.toLowerCase();
  } else {
    if (typeof window === 'undefined') return null;
    userAgent = navigator.userAgent.toLowerCase();
  }
  return userAgent.indexOf('iphone') > 0;
}

export function isIPad(serverUserAgent?: string) {
  let userAgent;
  if (serverUserAgent) {
    userAgent = serverUserAgent.toLowerCase();
  } else {
    if (typeof window === 'undefined') return null;
    userAgent = navigator.userAgent.toLowerCase();
  }
  return userAgent.indexOf('ipad') > 0;
}

export function isAndroid(serverUserAgent?: string) {
  let userAgent;
  if (serverUserAgent) {
    userAgent = serverUserAgent.toLowerCase();
  } else {
    if (typeof window === 'undefined') return null;
    userAgent = navigator.userAgent.toLowerCase();
  }
  return userAgent.indexOf('android') > 0 && userAgent.indexOf('chrome') > 0;
}
